<template>
    <div class="form-container">
        <div class="mb-3">
            <InputField
                name="employerName"
                ref="employerName"
                :customErrorMessage="$t('form.fields.employerName.errorMessage')"
                :validationRules="employerNameValidationRules"
                :label="$t('form.fields.employerName.label')"
            />
        </div>

        <div class="mb-3">
            <InputField
                v-if="territory === 'pol' || territory === 'aus'"
                name="jobTitle"
                :customErrorMessage="$t('form.fields.jobTitle.errorMessage')"
                :validationRules="jobTitleValidationRules"
                :label="$t('form.fields.jobTitle.label')"
            />

            <AutocompleteField
                v-else
                :name="jobTitle"
                :validationRules="jobTitleValidationRules"
                :customErrorMessage="$t('form.fields.jobTitle.errorMessage')"
                :noResultsErrorMessage="$t('form.fields.employmentIndustry.noResultsErrorMessage')"
                :label="$t('form.fields.jobTitle.label')"
                :limit="5"
                :options="jobTitleOptions"
                :defaultOption="['title', 'Other']"
                :appendDefaultOption="true"
            />
        </div>

        <div v-if="territory !== 'aus'" class="mb-3">
            <InputField
                name="taxId"
                :customErrorMessage="taxIdError"
                :validationRules="taxIdValidationRules"
                :label="taxIdLabel"
            />
        </div>
    </div>
</template>

<script>
import { useStore } from 'vuex'
import { taxIdLabel } from '@js/utilities/language.js'

// lodash components
import forEach from 'lodash/forEach'

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'employerDetails',
            route: {
                relativeUrl: process.env.TERRITORY === 'pol' ? `nazwa-firmy` : `employer-details`,
                name: 'apply.employerDetails',
                meta: {
                    title: 'form.sections.employment.employer.heading',
                    tooltip: 'form.sections.employment.employer.tooltip',
                    tooltipType: 'small',
                },
            },
            fields: {
                employerName: {
                    value: null,
                    mappedKey: 'employer_name',
                    validationRules: {
                        required: true,
                        max: 50,
                    },
                },
                jobTitle: {
                    value: null,
                    mappedKey: 'job_title',
                    validationRules: {
                        required: true,
                    },
                },
                taxId:
                    process.env.TERRITORY === 'pol'
                        ? {
                              value: null,
                              mappedKey: 'tax_id',
                              validationRules: {
                                  required: true,
                                  max: 10,
                                  nip: true,
                              },
                              hideOnSummary: true,
                              ignorePrepopulation: true,
                          }
                        : null,
            },
        }
    },

    data() {
        return {
            jobTitle: 'jobTitle',
            employerNameValidationRules: this.store.getters.fieldValidationRules('employerName'),
            jobTitleValidationRules: this.store.getters.fieldValidationRules('jobTitle'),
            taxIdValidationRules: this.store.getters.fieldValidationRules('taxId'),
            jobTitleOptions: [],
        }
    },
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    created() {
        this.emitter.emit('stepLoaded')
    },
    computed: {
        territory: function () {
            return process.env.TERRITORY
        },
        taxIdLabel: function () {
            return taxIdLabel()
        },
        taxIdError: function () {
            if (this.store.getters.fieldValue('employmentStatus') <= 3) {
                return this.$t('form.fields.nipPracodawcy.errorMessage')
            }

            return this.$t('form.fields.nipNumer.errorMessage')
        },
    },
    mounted() {
        this.autoFocus(this.$refs.employerName)
        const jobTitle = this.$i18n.messages[this.$i18n.locale].form.fields.jobTitle.options

        if (jobTitle) {
            forEach(jobTitle, (value, key) => {
                this.jobTitleOptions.push({
                    id: value.value,
                    title: value.name,
                    ref: key + value.name,
                })
            })
        }
    },
}
</script>
